/* @flow */

import type { RoleList } from './defs';
import { Roles } from './defs';

///////////////////////////////
// Model masters permissions //
///////////////////////////////
// Create Permissions //
////////////////////////
export const create: RoleList = [
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
  // Roles.SYSTEM_ADMIN_REGIONAL,
];

//////////////////////
// Read Permissions //
//////////////////////
export const read: RoleList = [
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

////////////////////////
// Update Permissions //
////////////////////////
export const update: RoleList = [
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
  // Roles.SYSTEM_ADMIN_REGIONAL,
];
